var map = {
	"./en/auth.js": 94936,
	"./en/calendar.js": 80168,
	"./en/credits.js": 38082,
	"./en/dashboard.js": 58780,
	"./en/editor.js": 76243,
	"./en/errors.js": 39197,
	"./en/form.js": 2992,
	"./en/horseChestnut.js": 20297,
	"./en/menu.js": 73257,
	"./en/misc.js": 48398,
	"./en/modal.js": 65589,
	"./en/page.js": 89389,
	"./en/publicationSuggestion.js": 53906,
	"./en/task.js": 67071,
	"./en/tutorial.js": 31768,
	"./fr/auth.js": 56849,
	"./fr/calendar.js": 41353,
	"./fr/credits.js": 11437,
	"./fr/dashboard.js": 85555,
	"./fr/editor.js": 81450,
	"./fr/errors.js": 38516,
	"./fr/form.js": 8529,
	"./fr/horseChestnut.js": 41562,
	"./fr/menu.js": 77244,
	"./fr/misc.js": 46263,
	"./fr/modal.js": 81218,
	"./fr/page.js": 90536,
	"./fr/publicationSuggestion.js": 76721,
	"./fr/task.js": 5926,
	"./fr/tutorial.js": 40021
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7199;